import { type FC, useId, useRef, useState } from 'react'
import { Form } from 'react-bootstrap'
import { type LexicalEditor } from 'lexical'
import { CrmRichTextEditor } from '../../../../../../../views/CrossClient/Actions/modals/CrmRichTextEditor'
import { getEditorHtmlContent } from '../../../MeetingResults/Lexical/utils'
import { buildWorkflowDescriptionHtml } from '../integrationWorkflow'
import { DateField, StartWorkflowActions, type StartWorkflowFormProps } from '../StartWorkflowFields'
import { redtailWorkflowAdapter } from './redtailWorkflowAdapter'

export const RedtailStartWorkflowForm: FC<StartWorkflowFormProps> = ({ target, template, suggestedLabel, suggestedSummary, onStarted }) => {
  const [name, setName] = useState(suggestedLabel || template.name || '')
  const [targetDate, setTargetDate] = useState<Date | null>(() => new Date())
  const descriptionEditorRef = useRef<LexicalEditor>(null)
  const nameId = useId()
  const initialDescriptionHtml = buildWorkflowDescriptionHtml(template.description, suggestedSummary)

  const readDescriptionHtml = () => {
    const editor = descriptionEditorRef.current
    return editor ? (getEditorHtmlContent(editor.getEditorState()) ?? undefined) : undefined
  }

  const trimmedName = name.trim()
  const buildPayload =
    trimmedName && targetDate
      ? () =>
          redtailWorkflowAdapter.buildStartPayload(
            { templateId: template.id, name: trimmedName, dueDate: targetDate, description: readDescriptionHtml() },
            target.externalId,
          )
      : null

  return (
    <div className='d-flex flex-column gap-3'>
      <div>
        <Form.Label htmlFor={nameId}>Workflow name</Form.Label>
        <Form.Control id={nameId} value={name} onChange={(event) => setName(event.target.value)} />
      </div>
      <div>
        <Form.Label>Description</Form.Label>
        <CrmRichTextEditor
          key={initialDescriptionHtml}
          ref={descriptionEditorRef}
          variant='task'
          initialHtmlValue={initialDescriptionHtml}
          placeholder={<>Describe the workflow…</>}
        />
      </div>
      <div className='d-flex flex-column align-items-start'>
        <Form.Label>Target date</Form.Label>
        <DateField label='Target date' value={targetDate} placeholder='Pick a target date' onChange={setTargetDate} />
      </div>
      <StartWorkflowActions target={target} templateId={template.id} buildPayload={buildPayload} onStarted={onStarted} />
    </div>
  )
}
